import { useContext, useEffect, useMemo } from 'react'
import { Context } from 'scala'
import { useDownloadTaskSplit } from '../../../../hooks/tasks/use-download-task-split'
import { useTrackSplit } from '../../../../hooks/tasks/use-track-split'
import { Task, TaskOperations } from '../../../../types'
import { useStorePlayer } from '../store'
import { UsePersistedSettings } from '../../../../hooks/player/use-persisted-channel-settings'
import { useGenerateMixNew } from '../../../../hooks/tasks/use-generate-mix-new'

interface Props {
  task: Task
  isHifi: boolean
  mainOperations: TaskOperations[]
  persistedSettings: UsePersistedSettings
}

export const useDataExport = ({
  task,
  isHifi,
  mainOperations,
  persistedSettings
}: Props): void => {
  const { user } = useContext(Context)
  const { setData } = useStorePlayer()
  const taskWithCurrentOperation = useMemo(
    () => ({ ...task, operations: mainOperations }),
    [task, mainOperations]
  )
  const isDownloadWavEnabled = user?.subscription?.isPremium

  const { audio } = useTrackSplit({
    task: taskWithCurrentOperation,
    keepStemName: true
  })

  const { onGenerateMix: onGenerateMixNewPlayer } = useGenerateMixNew({
    trackId: task?.id,
    name: task?.file?.name,
    tracks: audio.tracks,
    persistedSettings,
    isHifi
  })

  const { files } = useDownloadTaskSplit({
    task: taskWithCurrentOperation,
    tracks: audio.tracks,
    isDownloadWavEnabled,
    onGenerateMixNewPlayer,
    newPlayer: true,
    isHifi
  })

  useEffect(() => {
    if (files) {
      setData({
        export: files
      })
    }
  }, [files, setData])
}
